'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.default = Spinner;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./spinner.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * WH Spinner component.
 * @param {Object} props The new component properties.
 * @returns {React$Element<any>}  HTML markup for the component
 */
function Spinner(props) {
    var _cx;

    var _props$className = props.className,
        className = _props$className === undefined ? '' : _props$className,
        _props$id = props.id,
        id = _props$id === undefined ? '' : _props$id,
        _props$size = props.size,
        size = _props$size === undefined ? '' : _props$size,
        _props$theme = props.theme,
        theme = _props$theme === undefined ? '' : _props$theme;


    var classNames = (0, _classnames2.default)((_cx = {
        'sb-spinner': true
    }, (0, _defineProperty3.default)(_cx, 'sb-spinner--' + theme, theme), (0, _defineProperty3.default)(_cx, 'sb-spinner--' + size, size), (0, _defineProperty3.default)(_cx, '' + className, className), _cx));

    return (0, _jsx3.default)('div', {
        className: classNames,
        id: id
    });
}
//# sourceMappingURL=Spinner.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/spinner/Spinner.js
// module id = 605
// module chunks = 0